import React, { useState, useEffect } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'src/redux/root-reducer'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { getAllBanksAction } from 'src/redux/actions/bankAction'
import Select from 'react-select'
import { LabelText } from 'src/components/Global/Text/TitleText'

const QuicksaveAmount = () => {
  const [planData, setPlanData] = useState({
    amount_to_save: '',
    id: '',
    saving_into: '',
  })

  const myPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans.plans
  )
  console.log(myPlans, 'here')
  let location = useLocation()
  const dispatch = useDispatch()
  const { amount_to_save, saving_into } = planData

  useEffect(() => {
    dispatch(getAllBanksAction())
    dispatch(action(PlanTypes.CLEAR_PAYMENT_FORM))
  }, [dispatch])
  const checkurl = () => {
    if (window.location.href.indexOf('quicksave') > -1) {
      return 'quicksave'
    }
  }
  const type = checkurl()
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, newData))
  }
  const handleOption = (options: any) => {
    planData.id = options.value
    planData.saving_into = options.label
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, planData))
  }

  //react-select style
  const style = {
    control: (base: any) => ({
      ...base,
      // border: 0,
      // This line disable the blue border
      boxShadow: 'none',
      border: '1px solid #6e7191',
      height: '55px',
      borderRadius: '10px',
      marginBottom: '30px',
    }),
  }

  const options = myPlans?.map((plan: any) => {
    return {
      value: plan?.id,
      label: plan?.name,
      id: plan?.id,
    }
  })
  const quickSave = (e: any) => {
    if (!amount_to_save || !planData.saving_into) {
      e.preventDefault()
    } else {
    }
    // setShowModal(true)
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <h2 className="title">Amount to save</h2>
          <div className="input_wrapper">
            <p className="desc">Enter amount to save?</p>
            <QuicksaveInput
              type="number"
              name="amount_to_save"
              value={amount_to_save}
              placeholder="100,000"
              onChange={handleChange}
            />
          </div>
          <div className="bank-inputs-container input_wrapper">
            <p className="input-title">Select Plan to Save into</p>
            <Select
              name={options?.label}
              value={options?.value}
              placeholder="Select plan"
              options={options}
              onChange={handleOption}
              className="bank_code_select"
              styles={style}
            />
          </div>
          {options.length === 0 && (
            <LabelText className="information">
              Create a plan to save into
            </LabelText>
          )}
        </div>
        <div>
          <Link
            to={`/${type}-payment-detail`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="button" onClick={quickSave}>
              Continue
            </ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { QuicksaveAmount }
